import { convertDateTime } from "Helpers/date";
import moment from "moment";
import Visa from "Assets/images/visa.svg";
import MasterCard from "Assets/images/mater-card.svg";
import AmericanExpress from "Assets/images/amex.svg";
import Discover from "Assets/images/discover.svg";
import { PAYABLI_NOT_ALLOW_STORE, PAYMENT_METHODS } from "Helpers/Constants";

export const DATE_TIME_FORMAT = "yyyy-LL-dd HH:mm";
export const START_TIME_OF_DATE = "00:00 AM";
export const END_TIME_OF_DATE = "11:59 PM";
export const START_TIME_OF_DATE_TWENTY_FOUR = "00:00";
export const END_TIME_OF_DATE_TWENTY_FOUR = "23:59";
export const CUSTOM_ANYTIME = "07:00 PM";
export const CUSTOM_DEFAULT_TIME = "03:00 PM";

export function utctimeToPSTTime(utcdate,date,time,orderTimezone) {
  if (!time) {
    return;
  }
  if(utcdate && utcdate != undefined)
  {
    let d = convertDateTime(`${utcdate}`, "format7", DATE_TIME_FORMAT, "", orderTimezone);
    if (d.isValid) {
      return d.toFormat("hh:mm a");
    } else {
      return "";
    }  
  }
  else if(date) {
    let d = convertDateTime(`${date} ${time}`, "format7", "yyyy-LL-dd hh:mm a", "", orderTimezone);
    if (d.isValid) {
      return d.toFormat("hh:mm a");
    } else {
      return "";
    }  
  }else{
    return convertDateTime(time, "format2", "hh:mm a", "hh:mm a", orderTimezone);
  }
}
export function pstToUTCDateTime(day, timeStamp, providedTime, orderTimezone) {
  let date = moment(day).format("YYYY-MM-DD");
  let time = "";
  if (timeStamp) {
    time = convertDateTime(timeStamp, "seconds", "hh:mm a", "", orderTimezone);
  } else {
    time = providedTime;
  }
  return convertDateTime(`${date} ${time}`, "format3", DATE_TIME_FORMAT, "yyyy-LL-dd hh:mm a", orderTimezone);
}

export function timeStamptoPSTime(timeStamp, orderTimezone) {
  if (!timeStamp) return;
  let time = convertDateTime(timeStamp, "seconds", "h:mm a", "", orderTimezone);
  return time;
}

export function utcDateTimeToTime(date_time) {
  return convertDateTime(`${date_time}`, "format4", "hh:mm a", DATE_TIME_FORMAT);
}

export function utcDateTimeToPSTTime(date_time, orderTimezone) {
  let d = convertDateTime(`${date_time}`, "format7", DATE_TIME_FORMAT, "", orderTimezone);
  if (d.isValid) {
    return d.toFormat("hh:mm a");
  } else {
    return "";
  }
}

export function utcTimeToDate(date_time) {
  return convertDateTime(`${date_time}`, "format4", "yyyy-LL-dd", DATE_TIME_FORMAT);
}

// export function utcTimeToPSTTime(time) {
//   if (
//     convertDateTime(`${time}`, "format9", "hh:mm a")
//   ) {
//     return convertDateTime(`${time}`, "format10", "hh:mm a", "hh:mm a");
//   } else {
//     return "";
//   }
// }

export function utcISOStringToPSTDate(date_time, orderTimezone) {
  if (!date_time) {
    return "";
  }
  return convertDateTime(date_time, "iso2", "yyyy-LL-dd", "", orderTimezone);
}

export function ISOtoDateTime(iso) {
  if (!iso) {
    return "";
  }
  return convertDateTime(iso, "iso3", DATE_TIME_FORMAT);
}

export function increment(product) {
  product.qty = product.qty + 1;
  product.total_price = product.qty * product.selectedVariant.price;
  return product;
}
export function decrement(product) {
  if (product.qty === 1) {
    return product;
  }
  product.qty = product.qty - 1;
  product.total_price = product.qty * product.selectedVariant.price;
  return product;
}

export function deleteProds(prods, i) {
  let ads = [...prods];
  ads.splice(i, 1);
  return ads;
}

//Remove store id from product_variation_storeIds if products is deleted
export function deleteProductStoreIds(storeIds, index) {
  if (index >= 0 && index < storeIds.length) {
    storeIds.splice(index, 1);
  }
  return storeIds;
}

// get latest store id on behalf of zip code and delivery address
// add store id in storeIds array
export function storeIdsForStoreProductVariation(products) {
  let storeIds = [];
  for (const product of products) {
    const selectedStoreProductVariationStoreId = product?.selectedVariant?.store_product_variations[0]?.store_id;
    storeIds.push(selectedStoreProductVariationStoreId);
  }
  return storeIds;
}

export function getCardImage(card_type) {
  switch (card_type.toLowerCase()) {
    case "visa":
      return Visa;
    case "maestro":
      return MasterCard;
    case "master-card":
      return MasterCard;

    case "american-express":
      return AmericanExpress;
    case "mastercard":
      return MasterCard;
    case "american express":
      return AmericanExpress;
    case "discover":
      return Discover;
    case "amex":
      return AmericanExpress;
    default:
      return null;
  }
}

//Validate to not allow for specific store to place order
/**
 * @param {*} paypoint
 * @param {*} storeId
 * @returns boolean {true/false}
 */
export function validateNotAllowStoreOrder(
  payment_method,
  paypoint = null,
  storeId = 0
) {
  if (
    payment_method === PAYMENT_METHODS.PAYABLI &&
    (!paypoint || paypoint === "" || paypoint === null)
  ) {
    return true;
  } else if (
    payment_method === PAYMENT_METHODS.PAYABLI &&
    storeId &&
    +storeId > 0
  ) {
    const notAllowStores = PAYABLI_NOT_ALLOW_STORE;
    if (notAllowStores.includes(storeId)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

//check if price is same as unit price or not
export const checkPriceDefference = (amount1, amount2) => {
  amount1 = parseFloat(amount1 || 0).toFixed(2);
  amount2 = parseFloat(amount2 || 0).toFixed(2);
  if (amount1 === amount2) {
    return true;
  }
  return false;
};

//Parse html to plain text
export const htmlToPlainText = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  return doc.body.textContent || '';
}

export const formatRawMaterialListData = (data) => {
  return data.map((item) => {

    const rawMaterial = item?.product_recipe_raw_material;
    if (!rawMaterial) {
      return null;
    }
    
    return {
      id: rawMaterial.id,
      title: rawMaterial.title,
      product_recipe_types_id: rawMaterial.product_recipe_type?.id,
      product_recipe_units_id: rawMaterial.product_recipe_unit?.id,
      image: rawMaterial.image,
      whole_sale_price: rawMaterial.whole_sale_price,
      retail_price: rawMaterial.retail_price,
      status: rawMaterial.status,
      product_recipe_type: rawMaterial.product_recipe_type,
      product_recipe_unit: rawMaterial.product_recipe_unit,
      product_recipe_raw_materials_prices: rawMaterial.product_recipe_raw_materials_prices,
    };
  }).filter(item => item !== null);
};

export function removePlusAndSpace(str) {
  return str.replace(/[^.]/g, '');
}

export function keepNumbersOnly(str) {
  return str.replace(/[^0-9]/g, '');
}

  /**
   * Formats an amount to 2 decimal places
   * @param {number} amount - The amount to format
   * @returns {string} - The formatted amount
   */
  export function formatAmount(amount = 0) {
    return Number(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };